import React from "react";

const JournalArchive = () => {
  return <div>JournalArchive</div>;
};

export default JournalArchive;
